import { Navigate } from "react-router-dom";
import { decodeJwtPayload } from "../utils/jwt";

const SEVEN_DAYS = 7 * 24 * 60 * 60 * 1000;

export default function RoleProtectedRoute({ children, role }: any) {
  const token = localStorage.getItem("token");

  if (!token) return <Navigate to="/" />;

  const lastSeen = localStorage.getItem("sessionLastSeen");
  if (!lastSeen || Date.now() - Number(lastSeen) >= SEVEN_DAYS) {
    localStorage.removeItem("token");
    localStorage.removeItem("sessionLastSeen");
    return <Navigate to="/" />;
  }

  localStorage.setItem("sessionLastSeen", Date.now().toString());

  const payload = decodeJwtPayload(token);
  if (!payload) {
    localStorage.removeItem("token");
    localStorage.removeItem("sessionLastSeen");
    return <Navigate to="/" />;
  }

  if (payload.role !== role) {
    return <h2>Access Denied</h2>;
  }

  return children;
}
